export const requiredFieldsQuery = {
  bool: {
    must: [
      {
        exists: {
          field: 'horseRacingSportsData',
        },
      },
      {
        exists: {
          field: 'horseRacingSportsData.jockey',
        },
      },
      {
        exists: {
          field: 'horseRacingSportsData.owner',
        },
      },
      {
        exists: {
          field: 'horseRacingSportsData.trainer',
        },
      },
      {
        exists: {
          field: 'horseRacingSportsData.horseName',
        },
      },
      {
        exists: {
          field: 'marketMovement',
        },
      },
      {
        exists: {
          field: 'marketMovement.rationaleText',
        },
      },
    ],
  },
};
